import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { FormUtilsService } from '@app/@core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ChangePassword, ChangePasswordValidationMessages } from '../models';

@Injectable()
export class ChangePasswordService {
  readonly form: UntypedFormGroup;
  readonly validationMessages: ChangePasswordValidationMessages;

  constructor(private formUtils: FormUtilsService) {
    this.form = this.buildForm();
    this.validationMessages = this.buildValidationMessages();
  }

  save(): ChangePassword | null {
    if (this.form.valid) {
      return this.form.getRawValue();
    } else {
      this.formUtils.markAsDirty(this.form);
      return null;
    }
  }

  private buildForm() {
    const password = new UntypedFormControl(null, Validators.compose([Validators.required, Validators.minLength(5)]));
    const confirmPassword = new UntypedFormControl(null, this.equalTo(password));

    return new UntypedFormGroup(
      {
        password,
        confirmPassword
      },
      {
        updateOn: 'change'
      }
    );
  }

  private buildValidationMessages(): ChangePasswordValidationMessages {
    return {
      password: [
        { type: 'required', message: marker('err_field_required') },
        { type: 'minlength', message: marker('err_password_min_length') }
      ],
      confirmPassword: [{ type: 'equalTo', message: marker('err_password_confirm') }]
    };
  }

  /**
   * Lokalny zamiennik CustomValidators.equalTo
   */
  private equalTo(otherControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !otherControl.value) return null;
      return control.value === otherControl.value ? null : { equalTo: true };
    };
  }
}
